import { NotificationStatus } from "../../types/notifications";

/** Минимум, по которому решается вопрос «прочитано ли». */
export type ReadStateBearingNotification = {
  status?: NotificationStatus | string | null;
  isRead?: boolean;
};

/**
 * Прочитано ли уведомление (AD-151).
 *
 * ПОЧЕМУ ОДНОГО ПОЛЯ НЕ ХВАТАЕТ. Сервер хранит прочитанность в колонке `status`
 * (`unread`/`read`/…), а `isRead` у сущности `Notification` — ГЕТТЕР НА
 * ПРОТОТИПЕ поверх неё. Ответ собирается спредом `{...notification}`
 * (`notifications.service.ts`), а спред и `JSON.stringify` копируют только
 * СОБСТВЕННЫЕ перечислимые свойства — прототипный геттер теряется в обоих.
 * Проверено исполнением: `Object.keys(n).includes('isRead')` → `false`.
 * Значит на клиенте `isRead` у пришедших с сервера уведомлений `undefined`
 * ВСЕГДА, а `!undefined` — истина: каждое уведомление вечно выглядело
 * непрочитанным, фильтр «только непрочитанные» пропускал всё, счётчики по типам
 * были завышены. Цифра на колокольчике при этом верна — её считает отдельный
 * запрос `GET /notifications/unread-count`, отсюда и расхождение «бейдж ноль,
 * а список весь подсвечен».
 *
 * ПОЧЕМУ `isRead` ВСЁ РАВНО ЧИТАЕТСЯ ПЕРВЫМ. Локальные писатели ставят его сами:
 * редьюсеры `markAsRead`/`markAllAsRead` ставят ОБА поля, но обновление кэша
 * React Query в `useNotifications` ставит ТОЛЬКО `isRead`. Отдай мы приоритет
 * `status`, эта оптимистичная отметка стала бы невидимой. Поэтому порядок такой:
 * явный локальный булев признак сильнее, серверный `status` — источник по
 * умолчанию.
 *
 * НЕИЗВЕСТНОЕ СЧИТАЕТСЯ НЕПРОЧИТАННЫМ: это сохраняет прежнее поведение на
 * данных без обоих полей и ошибается в безопасную сторону — показать лишнее
 * «новое» не вредно, спрятать настоящее новое — вредно.
 */
export function isNotificationRead(
  notification: ReadStateBearingNotification,
): boolean {
  if (typeof notification.isRead === "boolean") {
    return notification.isRead;
  }

  if (notification.status == null) {
    return false;
  }

  return notification.status !== NotificationStatus.UNREAD;
}
